module.exports = __webpack_public_path__ + "img/xmasParty10.e19f976d.jpg";